import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { useSelector } from "react-redux";
import { Menu } from "lucide-react";

const MiniLayout = ({ children }) => {
  const role = useSelector((s) => s.auth.employeeDetails.role);
  const onboardingitems = useSelector((s) => s.auth.onboardingitems);
  const compalinceitems = useSelector((s) => s.auth.compalinceitems);
  const rmdashboarditems = useSelector((s) => s.auth.rmdashboarditems);
  const zhdashboarditems = useSelector((s) => s.auth.zhdashboarditems);
  const rsmdashboarditems = useSelector((s) => s.auth.rsmdashboarditems);
  const shdashboarditems = useSelector((s) => s.auth.shdashboarditems);
  const asmdashboarditems = useSelector((s) => s.auth.asmdashboarditems);
  const Aepsitems = useSelector((s) => s.auth.Aepsitems);
  const PayoutAccounting = useSelector((s) => s.auth.payoutaccountingitems);
  const Accounting = useSelector((s) => s.auth.accountingitems);
  const AccountingRole = useSelector((s) => s.auth.accountingiroletems);
  const superonboardingitems = useSelector(
    (s) => s.auth.superonboardingitems
  );

  let menuItems;
  if (role === "ONBOARDING") menuItems = onboardingitems;
  else if (role === "COMPLIANCE") menuItems = compalinceitems;
  else if (role === "AEPS_BACKEND") menuItems = Aepsitems;
  else if (role === "SUPER_ONBOARDING") menuItems = superonboardingitems;
  else if (role === "NATIONAL_HEAD") menuItems = rmdashboarditems;
  else if (role === "ZONAL_HEAD") menuItems = zhdashboarditems;
  else if (role === "REGIONAL_SALES_MANAGER") menuItems = rsmdashboarditems;
  else if (role === "STATE_HEAD") menuItems = shdashboarditems;
  else if (role === "ASM") menuItems = asmdashboarditems;
  else if (role === "PAYOUT_ACCOUNTING") menuItems = PayoutAccounting;
  else if (role === "HELPDESK_MANAGER") menuItems = Accounting;
  else if (role === "CASH_IN_MANAGER") menuItems = AccountingRole;

  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="w-screen h-screen bg-[#EEF1F5] overflow-hidden">
      {/* Mobile Header */}
      <div className="lg:hidden flex items-center gap-3 p-4 bg-white shadow-sm">
        <button onClick={() => setSidebarOpen(true)}>
          <Menu size={22} />
        </button>
        <span className="font-semibold">Dashboard</span>
      </div>

      {/* Desktop Toggle */}
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
         className="hidden md:block p-2 rounded-lg bg-white shadow m-2"
      >
        <Menu size={22} />
      </button>

      {/* Sidebar */}
      <Sidebar
        menuItems={menuItems}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Overlay (mobile only) */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <main
        className={`
    h-full overflow-auto p-4
    transition-all duration-300
    scrollbar-hide
    ${sidebarOpen ? "lg:ml-[280px]" : "ml-0"}
  `}
      >
        {children}
      </main>
    </div>
  );
};

export default MiniLayout;



